import { apiInstance } from '@crm/shared/api';
import { keysToCamel } from '@crm/shared/lib/objects';

import { companyApiRoutes } from './api-routes';

import type { TCompanyDTO } from '../model';
import type { TBaseResponseType } from '@crm/shared/model/BaseResponse.type';

export const companyApi = {
    getAvailableCompanies: async () => {
        const response = await apiInstance
            .get(companyApiRoutes.getAvailableCompaniesRoute())
            .json<TBaseResponseType<TCompanyDTO[]>>();

        return keysToCamel(response.data);
    },
    setActiveCompany: async (companyId: TCompanyDTO['id']) => {
        const response = await apiInstance
            .post(companyApiRoutes.setActiveCompanyRoute(companyId))
            .json<TBaseResponseType<TCompanyDTO>>();

        return keysToCamel(response.data);
    },
};
